import React from 'react';

export function NewHDGuardianConservator() {
  return (
    <div className="new-ha-guardian-conservator">
      <h1>Guardian/Conservator</h1>
      <p>Specify your preferences for guardianship and conservatorship arrangements.</p>
    </div>
  );
}